import React from "react";
import classnames from "classnames";
import getConfig from 'next/config';
import "./StickyWhatsapp.module.scss";

const StickyWhatsapp = () => {
  const { TSO_PHONE_NUMBER, WHATSAPP_NUMBER } = getConfig().publicRuntimeConfig;

  const redirectWhatsapp = () => {
    const text = 'Halo Lifepal, saya memiliki pertanyaan tentang produk asuransi';

    const WhatsAppAPI = `https://api.whatsapp.com/send/?phone=${WHATSAPP_NUMBER}&text=${encodeURIComponent(text)}&app_absent=0`;
    window.location.href = WhatsAppAPI;
  }

  return (
    <div className={classnames('stickyWhatsapp')}>
      <div className="wrap_button">
        <span className="cs-title">Dapatkan Penawaran</span>
        <div
          className={classnames('img_headset', 'gtm_whatsapppopup_buttonclick')}
          title="Call Me Bantuan">
          <a href={`tel:${TSO_PHONE_NUMBER}`}>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M2.5 4.16667C2.5 3.24619 3.24619 2.5 4.16667 2.5H6.89937C7.25806 2.5 7.57651 2.72953 7.68994 3.06981L8.93811 6.81434C9.06926 7.20777 8.89115 7.63776 8.52022 7.82322L6.63917 8.76375C7.55771 10.801 9.19898 12.4423 11.2363 13.3608L12.1768 11.4798C12.3622 11.1088 12.7922 10.9307 13.1857 11.0619L16.9302 12.3101C17.2705 12.4235 17.5 12.7419 17.5 13.1006V15.8333C17.5 16.7538 16.7538 17.5 15.8333 17.5H15C8.09644 17.5 2.5 11.9036 2.5 5V4.16667Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </a>
        </div>
        <span className='cs-divider'>|</span>
        <div
          className={classnames('img_wa', 'gtm_whatsapppopup_buttonclick')}
          title="Whatsapp Bantuan"
          onClick={() => redirectWhatsapp()}>
          <img className="img_icon" alt="whatsapp" loading="lazy" src="/static/images/homepage/whatsapp.svg" width="18px" height="18px" />
        </div>
      </div>
      <div className='cs-logo'>
        <img src={'/static/images/homepage/head-cs.svg'} />
      </div>
    </div>
  );
};

export default StickyWhatsapp;
